import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
    getSubActivity, AddSubActivity,
    getActivity,
    editSubActivity
} from '../../../helper/Api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Card,
  CardContent
} from "@mui/material";
const AddSubactivity = () => {
    let jsonData = {};
    const { id, data } = useParams();
    console.log("jsonData", id);
    // if (id && data) {
    //     jsonData = JSON.parse(data);
    // }
    const [activity, setActivity] = useState([]);
    const { authData } = useSelector((state) => state.authData);
    const [formData, setFormData] = useState({
        status: "1",
        activity_id: null,
        subactivity: null,
        created_by: authData && authData.status ? authData.user.id : null
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fetchActivity = async () => {
        const result = await getActivity();
        if (result.data.status) {
            setActivity(result.data.result)
        }
    }
    const handleFormData = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log(name, value);
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const previewHandler = (e) => {
        e.preventDefault();
    };
    const handleToggle = () => {
        setFormData({
            ...formData,
            status: formData.status === "0" ? "1" : "0",
        });
    }
    useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, [id])
    useEffect(() => {
        fetchActivity();
    }, [])
    const validateForm = () => {
        if (!formData.activity_id || !formData.subactivity) {
            return false;
        }
        return true;
    };
    const handleSubmit = async (e) => {
        if (!validateForm()) {
            alert('Please fill in all fields correctly.');
            return;
        }
        try {
            if (id) {
                const response = await editSubActivity(formData, id);
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/subactivity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
            else {
                const response = await AddSubActivity(formData);
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/subactivity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }
    const fetchData = async (id) => {
        const response = await getSubActivity({ id: id });
        if (response.data.status) {
            if (response.data.result.length) {
                setFormData(response.data.result[0])
                setFormData({ activity_id: response.data.result[0].activity_id, subactivity: response.data.result[0].subactivity, status: response.data.result[0].status })
            }
        }
    }
    const linksArray = [
        {
          href: "/department/subactivity",
          label: "Subctivities",
        }
      ]
    return (
        <div>
            <div className="p-3">
                <div className="row">
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Add Subactivity</h4>
                        <CustomBreadcrumbs linksArray={linksArray} title="Add Subactivity"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button
                                type="button"
                                className="submit_button"
                                onClick={handleSubmit}
                                ><span className="fs-14px">Save</span>
                            </button>
                        </div>
                        
                    </div>
                </div>
                <div className="row" style={{marginTop: '10px'}}>
                    <Form onSubmit={previewHandler}>
                        <div className="col-md-12">
                            <Card>
                                <CardContent>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <FormControl fullWidth>
                                                <InputLabel id="scheme-namelabel">Activity</InputLabel>
                                                <Select
                                                    labelId="scheme-namelabel"
                                                    id="scheme-name-select"
                                                    value={formData.activity_id || ""}
                                                    label="Activity"
                                                    name="activity_id"
                                                    onChange={handleFormData}
                                                    required
                                                >
                                                    {activity.map((st) => (
                                                        <MenuItem value={st.id} key={st.id}>
                                                             {st.activity}
                                                        </MenuItem> 
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-sm-6">
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="subactivity"
                                                    label="Subactivity Name"
                                                    variant="outlined"
                                                    type="text"
                                                    name="subactivity"
                                                    value={formData.subactivity || ""}
                                                    onChange={handleFormData}
                                                    required
                                                />
                                            </FormControl>
                                        </div>
                                        {id && (
                                            <div className="col-sm-6 mt-2">
                                                <div className="form-group row">
                                                    <label htmlFor="inputType" className="col-sm-4 col-form-label">
                                                        Status
                                                        <span className="text-danger">*</span> :
                                                    </label>
                                                    <div className="col-sm-8">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                id="active"
                                                                name="status"
                                                                value={formData.status} onChange={handleToggle}
                                                                checked={formData.status === "1"}
                                                            />
                                                            <label className="form-check-label" htmlFor="active">
                                                                Active
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                id="inactive"
                                                                name="status"
                                                                value={formData.status}
                                                                onChange={handleToggle}
                                                                checked={formData.status === "0"}
                                                            />
                                                            <label className="form-check-label" htmlFor="inactive">
                                                                Inactive
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )

};
export default AddSubactivity;